import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { Button, NativeSelect, Paper, Checkbox } from "@material-ui/core";
import api from "../../../../services/api";
import { useParams } from "react-router-dom";
import "../../TargetReport/TableContent/index.css";
import { useMessageBox } from "../../../../context/MessageBox";
import excelIcon from "../../../../assets/images/excel48.png";
import pdfIcon from "../../../../assets/images/pdf.png";
import * as S from './formStyle';
import { capitalizeFirstLetter } from '../../../../utils/functions';
import AnchorsLogoOptions from './AnchorsLogoOptions'

import { toast } from "react-toastify";
function OperationsMiddle({
  setTableData,
  setProjecaoTableData,
  setProjecaoTotalTableData,
  setHeaderData,
  setTotalTableData,
  updateMetaData,
  setIsLoading,
  isLoading,
  anchors,
  handleSelectAnchor,
  selectedAnchor
}) {
  const classes = S.useStyles();
  const { periodo } = useParams();
  const [destinoPagamento, setDestinoPagamento] = useState("0");
  const [destinoOpcoes, setDestinoOpcoes] = useState([]);
  // // Simular dia 31
  // const date = new Date('May 31, 2022 20:15:00');
  // //  date.setDate(1);
  // const prindate = new Date('May 31, 2022 20:15:00');
  // //  prindate.setDate(1);
  // date.setMonth(date.getMonth() - 1);
  // const [refDate, setRefDate] = useState(date);
  // console.log(date);
  // const [mainDate, setMainDate] = useState(prindate);
  // console.log(prindate);

  // Solução

  const dateReference = new Date();
  dateReference.setDate(1);
  dateReference.setMonth(dateReference.getMonth()-1);
  const datePrincipal = new Date();
  datePrincipal.setDate(1);
  const [refDate, setRefDate] = useState(dateReference);
  const [mainDate, setMainDate] = useState(datePrincipal);
  const [mostrarIgnorados, setMostrarIgnorados] = useState('Todos')
  const [corporate, setCorporate] = useState('Todos')
  // Como estava

  // const [refDate, setRefDate] = useState(
  //   new Date().setMonth(new Date().getMonth() - 1)
  // );
  // const [mainDate, setMainDate] = useState(new Date());

  const [report, setReport] = useState();
  const [screenParams, setScreenParams] = useState({
    title: "Relatório Metas",
    apiTable: "Relatorios/Relatorio001Producao",
    apiDownload: "Relatorios/Relatorio001ProducaoDownloadExcel",
    apiDownloadExcel: "Relatorios/Relatorio001ProducaoDownloadExcel",
    dateFormat: "MM/yyyy",
  });

  const { setMessageData } = useMessageBox();

  useEffect(async () => {
    if (refDate && mainDate && destinoPagamento && selectedAnchor) {
      await getInfoForForm();
    }
  }, [refDate, mainDate, destinoPagamento, selectedAnchor, mostrarIgnorados, corporate]);

  useEffect(() => {
    const initialize = async () => {
      setIsLoading(true);
      await fetchDestinoPagamentos();
      setIsLoading(false);
    };
    initialize();
  }, []);

  const fetchDestinoPagamentos = async () => {
    try {
      const destinos = await api.get('DestinosPagamentos/Consultar?status=Ativo')
      if (destinos && destinos.data && destinos.data.status == 'Sucesso') {
        setDestinoOpcoes(destinos.data.resposta)
      }
    } catch (err) {
      console.log(err);
    } finally { }
  }

  const getInfoForForm = async () => {
    const model = {
      mesPrincipal: {
        mes: new Date(mainDate).getMonth() + 1,
        ano: new Date(mainDate).getFullYear(),
      },
      mesReferencia: {
        mes: new Date(refDate).getMonth() + 1,
        ano: new Date(refDate).getFullYear(),
      },
      destinoPagamentoId: Number(destinoPagamento),
      ancoraId: selectedAnchor.ancoraId ? selectedAnchor.ancoraId : 0,
      plataformaId: selectedAnchor.plataformaId ? selectedAnchor.plataformaId : 0,
      filtroMostrarIgnorados: mostrarIgnorados,
      filtroPersonalizado: corporate,
    };
    setReport(model);
    setIsLoading(true);

    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }

        setIsLoading(false);
      } else {
        setTableData(relatorio.data.resposta.comparativo.itens);
        setTotalTableData(relatorio.data.resposta.comparativo.totalizador);
        setHeaderData(relatorio.data.resposta);
        setProjecaoTableData(relatorio.data.resposta.projecao.itens);
        setProjecaoTotalTableData(relatorio.data.resposta.projecao.totalizador);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = async (pdf) => {
    if (!report || pdf) return;
    setIsLoading(true);

    try {
      const url = pdf
        ? screenParams.apiDownload
        : screenParams.apiDownloadExcel;
      const relatorio = await api.post(url, report);

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement("a");
      a.href =
        "data:" +
        relatorio.data.resposta.contentType +
        ";base64," +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div style={{ height: "100%" }}>
        <div
          className='new-body-schedule'
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginTop: "20px",
            alignItems: 'center'
          }}>
          <div style={{ minWidth: '20%' }}>
            <AnchorsLogoOptions
              anchors={anchors}
              handleSelectAnchor={handleSelectAnchor}
              selectedAnchor={selectedAnchor}
            />
          </div>

          <div className='schedule-input'
            style={{ display: "flex", margin: "8px", alignItems: 'center', flexDirection: 'column' }}
          >
            <span className={classes.label}>Mês/Ano Referência: </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                value={refDate}
                style={{
                  minWidth: "20px",
                  width: "20px",
                  height: "23px",
                  paddingLeft: "20px",
                }}
                onClick={() => {
                  const newDate = new Date(refDate);
                  if (periodo === "diario") {
                    setRefDate(newDate.setDate(newDate.getDate() - 1));
                  } else {
                    setRefDate(newDate.setMonth(newDate.getMonth() - 1));
                  }
                }}>
                🢀
              </Button>
              <div
                style={{
                  padding: "0px 5px",
                  maxWidth: "150px",
                  height: "23px",
                }}>
                <DatePicker
                  selected={refDate}
                  onChange={(date) => setRefDate(date)}
                  dateFormat={screenParams.dateFormat}
                  locale='ptBR'
                />
              </div>

              <Button
                style={{ minWidth: "20px", width: "20px", height: "23px" }}
                onClick={() => {
                  const newDate = new Date(refDate);
                  if (periodo === "diario") {
                    setRefDate(newDate.setDate(newDate.getDate() + 1));
                  } else {
                    setRefDate(newDate.setMonth(newDate.getMonth() + 1));
                  }
                }}>
                🢂
              </Button>
            </div>
          </div>

          <div className='schedule-input'
            style={{ display: "flex", margin: "8px", alignItems: 'center', flexDirection: 'column' }}
          >
            <span className={classes.label}>Mês/Ano Principal: </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                style={{
                  minWidth: "20px",
                  width: "20px",
                  height: "23px",
                  paddingLeft: "20px",
                }}
                onClick={() => {
                  const newDate = new Date(mainDate);
                  setMainDate(newDate.setMonth(newDate.getMonth() - 1));
                  setRefDate(newDate.setMonth(newDate.getMonth() - 1));
                }}>
                🢀
              </Button>

              <div
                style={{
                  padding: "0px 5px",
                  maxWidth: "150px",
                  height: "23px",
                }}>
                <DatePicker
                  selected={mainDate}
                  onChange={(date) => {
                    setMainDate(date);
                    setRefDate(new Date().setMonth(date.getMonth() - 1));
                  }}
                  dateFormat={screenParams.dateFormat}
                  locale='ptBR'
                />
              </div>

              <Button
                style={{ minWidth: "20px", width: "20px", height: "23px" }}
                onClick={() => {
                  const newDate = new Date(mainDate);
                  setMainDate(newDate.setMonth(newDate.getMonth() + 1));
                  setRefDate(newDate.setMonth(newDate.getMonth() - 1));
                }}>
                🢂
              </Button>
            </div>
          </div>

          <div>
            <label className={classes.label}>Destino de Pagamentos</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="destinoPagamentos"
                className={classes.input}
                onChange={(e) => {
                  setDestinoPagamento(e.target.value)
                }}
                value={destinoPagamento}
              >
                <option value="0">Consolidado</option>
                {destinoOpcoes.map((destino) => (
                  <option key={destino.destinoPagamentoId} value={destino.destinoPagamentoId}>
                    {capitalizeFirstLetter(destino.destinoPagamento)}
                  </option>
                ))}
              </NativeSelect>
            </Paper>
          </div>

          <div>
            <label className={classes.label}>Mostrar Ignorados</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="destinoPagamentos"
                className={classes.input}
                onChange={(e) => {
                  setMostrarIgnorados(e.target.value)
                }}
                value={mostrarIgnorados}
              >
                <option value="Todos">Todos</option>
                <option value="Ignorados">Ignorados</option>
                <option value="NaoIgnorados">Não Ignorados</option>
              </NativeSelect>
            </Paper>
          </div>

          <div>
            <label className={classes.label}>Personalizado</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="corporate"
                className={classes.input}
                onChange={(e) => {
                  setCorporate(e.target.value)
                }}
                value={corporate}
              >
              <option value="Todos">Todos</option>       
              <option value="Corporate">Corporate</option>
              <option value="NaoCorporate">Não Corporate</option>
              <option value="Comissionado">Comissionado</option>
              <option value="NaoComissionado">Não Comissionado</option>
              <option value="CorporateComissionado">Corporate Comissionado</option>
              <option value="CorporateNaoComissionado">Corporate Não Comissionado</option>
              </NativeSelect>
            </Paper>
          </div>

          <div>
            <img
              src={excelIcon}
              onClick={() => {
                exportTable(false);
              }}
              style={{ cursor: "pointer", marginRight: "8px" }}></img>
            {/* <img src={pdfIcon} onClick={() => { exportTable(true) }} style={{ cursor: 'default', marginBottom: '4px' }} width="40"></img> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationsMiddle;
